import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { CHECKOUT_STEP_MAP, SELECT_BILLING_ADDRESS_STEP } from 'constants/checkoutFlow';

import Address from 'components/checkout/caap/address/Address';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import RightArrow from 'components/checkout/caap/RightArrow';
import css from 'styles/components/checkout/caap/address/billingAddress.scss';

const BillingAddress = (componentParams, { testId }) => {
  const {
    address,
    billingModalOpen,
    isBillingSameAsShipping,
    onChangeBillingAddressClick,
    purchaseId,
    showBillingAddress
  } = componentParams;

  if (!showBillingAddress) {
    return null;
  }

  if (billingModalOpen || !address) {
    return (
      <h4>Billing Address</h4>
    );
  }

  return (
    <div>
      <Row desktopOnly={true}>
        <RowSpan span="4">&nbsp;</RowSpan>
        <RowSpan span="7" data-test-id={testId('billingAddressContainer')}>
          {makeBilling({ isBillingSameAsShipping, address, forDesktop: true })}
          <Link
            onClick={onChangeBillingAddressClick}
            className={css.changeBillingAddressLink}
            to={`${CHECKOUT_STEP_MAP[SELECT_BILLING_ADDRESS_STEP]}?referrer=spc&pid=${purchaseId}`}
            data-test-id={testId('changeBillingAddress')}>Change</Link>
        </RowSpan>
      </Row>

      <Row mobileOnly={true}>
        <Link onClick={onChangeBillingAddressClick} to={`${CHECKOUT_STEP_MAP[SELECT_BILLING_ADDRESS_STEP]}?referrer=spc&pid=${purchaseId}`} data-test-id={testId('changeBillingAddress')}>
          <Row>
            <RowSpan span="10" data-test-id={testId('billingAddressContainer')}>
              {makeBilling({ isBillingSameAsShipping, address })}
            </RowSpan>
            <RowSpan span="2">
              <RightArrow />
            </RowSpan>
          </Row>
        </Link>
      </Row>
    </div>
  );
};

BillingAddress.contextTypes = {
  testId: PropTypes.func
};

const makeBilling = ({ address, isBillingSameAsShipping, forDesktop }) => (
  <div className={css.detail}>
    { forDesktop
      ? <strong className={css.billingAddressHeading}>Billing address:</strong>
      : <h4>Billing address</h4>
    }
    {
      isBillingSameAsShipping
        ? <div className={css.detail}>Same as shipping</div>
        : <Address
          nameOnAddressLine={forDesktop}
          address={address} />
    }
  </div>
);

export default BillingAddress;
